const existeNewsletter = document.querySelector("[formtype='POPUP'] form");
const modal = document.querySelector(".e-usebob__politica-privacidade");
const btn = document.querySelector("[data-btn='politica-privacidade']");

btn.addEventListener("click", () => { closeModal({ setCookies: true }) });

const existeCookiesPrivacidade = getCookie('politica-privacidade');

if (!existeCookiesPrivacidade) {

    if (existeNewsletter) {
        openModal();
    }
    else {
        openModal();
    }

}
else {
    closeModal({ setCookies: false });
}

function closeModal(handle) {
    modal.classList.remove("opacity");

    setTimeout(() => {
        modal.classList.remove("open");
        modal.classList.add("close");
    }, 400);

    if (handle.setCookies) {
        setCookie('politica-privacidade', 'entendi');
    }
}

function openModal() {
    modal.classList.add("opacity");

    setTimeout(() => {
        modal.classList.remove("close")
        modal.classList.add("open")
    }, 400);
}

function getCookie(keyCookie) {
    const currentArrayCookies = document.cookie.split('; ')

    const temCookie = currentArrayCookies.find(cookie => cookie.startsWith(keyCookie))

    if (temCookie) {
        const cookie = temCookie.split('=');
        return cookie;
    }
    else {
        return false;
    }

}

function setCookie(keyCookie, valueCookie) {
    document.cookie = `${keyCookie}=${valueCookie}; path=/; expires=Tue, 31 Dec 2024 23:59:59 GMT`;
}